module.exports = __webpack_public_path__ + "img/roddur.c731ed43.jpg";